import DrillDownModal from './drillDownModal.view';

export default DrillDownModal;
